// extracted by mini-css-extract-plugin
export var childSlot = "twoColumnWithNewsfeed-module--childSlot--2dfbf";
export var grid = "twoColumnWithNewsfeed-module--grid--8d3b4";
export var twoColumnWithNewsfeed = "twoColumnWithNewsfeed-module--twoColumnWithNewsfeed--6aeb7";